import { textLineHeightTokens } from "../../Typography/Typography.tokens";
import { TextInput } from "./TextInput.mjs";
import { jsx } from "react/jsx-runtime";
const TextArea = TextInput.styleable(({
  numberOfLines = 3,
  ...props
}, ref) => {
  const height = numberOfLines ? numberOfLines * textLineHeightTokens["text.lineHeight.regular"] : "auto";
  return /* @__PURE__ */jsx(TextInput, {
    height,
    multiline: !0,
    numberOfLines,
    rows: numberOfLines,
    tag: "textarea",
    textAlignVertical: "top",
    ...props,
    ref
  });
});
export { TextArea };
//# sourceMappingURL=TextArea.mjs.map
